import { render, staticRenderFns } from "./MessageAttachmentsForm.vue?vue&type=template&id=09a411b2&"
import script from "./MessageAttachmentsForm.vue?vue&type=script&lang=js&"
export * from "./MessageAttachmentsForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageAttachmentsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports